<template>
  <div class="container bv-example-row" v-if="displayMultipleCollection">
    <div class="row">
      <div class="p-0 col-10">
        <b>
          <span v-html="multipleCollectionHeading"></span>
          <br />
          <span v-html="multipleCollectionText"></span>
          <span
            v-if="multipleCollectionNote"
            class="d-inline-block icon ml-1 pb-3"
            v-popover.hover.bottom="multipleCollectionNote"
            >&#9432;</span
          >
        </b>
      </div>
      <div class="col-2">
        <select
            ref="multipleCollectionSpinner"
            v-model="selected"
            @change="changeMultipleCollectionCount"
            class="mb-3 w-2rem custom-select"
        >
            <option
                v-for="opt in multipleCollectionRange"
                :key="opt.value !== undefined ? opt.value : opt"
                :value="opt.value !== undefined ? opt.value : opt"
            >
                {{ opt.text !== undefined ? opt.text : opt }}
            </option>
        </select>
      </div>
    </div>

    <div
      class="modal fade inactivity"
      tabindex="-1"
      id="exceedMaximumModal"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content text-center">
          <div class="modal-body p-4">
            <p>{{ modalDesc }}</p>
            <button
              type="button"
              class="btn btn-tru-green w-auto btn--yes"
              @click.prevent="confirmCallback"
            >
              Yes
            </button>
            <button
              type="button"
              class="btn btn--white border-green w-auto btn--no"
              @click.prevent="denyCallback"
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateNoTz from "../../../../common/utils/DateNoTz";
import Texts from "../../../../common/utils/Texts";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";

export default {
  components: {
    ConfirmationModal,
  },
  props: {
    selectedService: {
      type: Object,
    },
  },
  data() {
    return {
      selected: 1,
      serviceData: null,
      forceRange: null,
      // --- Display Values
      displayMultipleCollection: false,
      displayStreamQuantities: false,

      modalDesc: null,
    };
  },
  computed: {
    TEXTS: () => Texts,
    bookingState: function () {
      return this.$store.getters.GET_BOOKING_STATE;
    },
    collectionData() {
      return this.bookingState ? this.bookingState.collectionData : null;
    },
    entitlementSummary() {
      return this.bookingState ? this.bookingState.entitlementSummary : null;
    },
    selectedServiceEntitlementId() {
      var service = this.selectedService;
      return service ? service.entitlement_setting_id : null;
    },
    selectedEntitlementSettings() {
      var entitlementSettings;

      var entitlementSummary = this.entitlementSummary;
      var serviceEntitlementId = this.selectedServiceEntitlementId;

      if (
        entitlementSummary &&
        Array.isArray(entitlementSummary.entitlementSettings) &&
        serviceEntitlementId
      ) {
        entitlementSettings = entitlementSummary.entitlementSettings.find(
          (settings) => settings.entitlement_setting_id == serviceEntitlementId
        );
      }

      return entitlementSettings;
    },
    multipleCollectionRange() {
      var range = [];
      var rangeMaximum = 0;

      var serviceEntitlementId = this.selectedServiceEntitlementId;
      var effectiveEntitlements = this.effectiveEntitlements;

      var perServiceMaxCountSetting = this.multipleCollectionSetting.per_service_max_count;
      // --- Check for ForceRange first
      var rangeMaximum;
      if (this.forceRange) {
        rangeMaximum = this.forceRange;
      } else if (serviceEntitlementId && effectiveEntitlements) {
        /*
          Stry: P2US417_BUG03
          Date: 2020-11-10
          Auth: Franco Mapua
          Desc: Replacing previous implementation to determing max multiple collection
        */
        rangeMaximum = this.determineMaxEntitlementsOfPeriods();

        // var entitlementPeriod = effectiveEntitlements.current // --- Default

        // var selectionMode = this.selectedEntitlementSettings ? this.selectedEntitlementSettings.entitlement_usage : null

        // if(selectionMode == "1"){ // --- CollectionDate
        //   // If there is a date selected, determine the period
        //   if(this.collectionData && this.collectionData.selectedPeriod){
        //     var selectedPeriod = this.collectionData.selectedPeriod
        //     var selectedDate = typeof selectedPeriod == "object" ? selectedPeriod.start : selectedPeriod
        //     selectedDate = new DateNoTz(selectedDate)

        //     var currentStart = new DateNoTz(this.entitlementSummary.currentPeriod.startDate)
        //     var currentEnd = new DateNoTz(this.entitlementSummary.currentPeriod.endDate)

        //     if(currentStart.convertToSeconds() <= selectedDate.convertToSeconds() && selectedDate.convertToSeconds() <= currentEnd.convertToSeconds()){
        //       entitlementPeriod = effectiveEntitlements.current
        //     }
        //     else{
        //       entitlementPeriod = effectiveEntitlements.next
        //     }
        //   }
        //   // else, default to current
        // }
        // else if(selectionMode == "2"){ // --- Booking Date
        //   entitlementPeriod = effectiveEntitlements.current
        // }

        // rangeMaximum = entitlementPeriod[serviceEntitlementId];
      }

      //RP-1191
      //desc: the number of entitlements to be used for multiple collection to be limited
      if (rangeMaximum) {
        //check isset per_Service_Max_Count field
        if (perServiceMaxCountSetting && perServiceMaxCountSetting > 0) {
          if (perServiceMaxCountSetting <= rangeMaximum) {
            for (let i = 1; i <= perServiceMaxCountSetting; i++) {
              range.push({
                value: i,
                text: i,
              });
            }
          } else {
            for (let i = 1; i <= rangeMaximum; i++) {
              range.push({
                value: i,
                text: i,
              });
            }
          }
        }else{
          for (let i = 1; i <= rangeMaximum; i++) {
            range.push({
              value: i,
              text: i,
            });
          }
        }
      }
      //end RP-1191

      return range;
    },
    multipleCollectionSetting() {
      var selectedServiceId = this.serviceData
        ? this.serviceData.service_setting_id
        : null;
      var multipleCollectionList = this.$store.getters.GET_MULTIPLE_COLLECTION
        ? this.$store.getters.GET_MULTIPLE_COLLECTION.list
        : null;
      if (selectedServiceId && Array.isArray(multipleCollectionList)) {
        var selectedMultipleCollectionSetting = multipleCollectionList.find(
          (setting) => setting.service_setting_id == selectedServiceId
        );
        this.$store.dispatch(
          "setActiveMultipleCollectionSetting",
          selectedMultipleCollectionSetting
        );
        this.$store.dispatch('setActiveMultipleServiceOtherBookingState', { selectedMultipleCollectionSetting })
        return selectedMultipleCollectionSetting;
      }
    },
    effectiveEntitlements() {
      var effectiveEntitlements;
      var entitlementSummary = this.entitlementSummary;
      if (entitlementSummary) {
        effectiveEntitlements = entitlementSummary.effectiveEntitlements;
      }
      return effectiveEntitlements;
    },
    multipleCollectionHeading() {
      if (
        this.multipleCollectionSetting &&
        this.multipleCollectionSetting.heading
      ) {
        return this.multipleCollectionSetting.heading;
      } else {
        return Texts.render("MULTIPLE_COLLECTION_HEADER");
      }
    },
    multipleCollectionText() {
      if (
        this.multipleCollectionSetting &&
        this.multipleCollectionSetting.text
      ) {
        return this.multipleCollectionSetting.text;
      } else {
        return Texts.render("MULTIPLE_COLLECTION_TEXT");
      }
    },
    multipleCollectionNote() {
      if (
        this.multipleCollectionSetting &&
        this.multipleCollectionSetting.note
      ) {
        return this.multipleCollectionSetting.note;
      }
    },
    multipleServiceBookingState() {
      return this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_OTHER_BOOKING_STATE
        .find(bstate => bstate.service_group_id === this.$store.getters.GET_ACTIVE_SERVICE_GROUP.service_group_id && bstate.service_setting_id === this.$store.getters.GET_ACTIVE_SERVICE_SETTING.service_setting_id);
    }
  },
  mounted() {
    this.$store.dispatch("getMultipleCollection");
  },
  watch: {
    collectionData(newData) {
      // --- Check if Collection type is
      var selectionMode = this.selectedEntitlementSettings
        ? this.selectedEntitlementSettings.entitlement_usage
        : null;
      var selectedServiceEntitlementId = this.selectedServiceEntitlementId;

      if (
        !newData ||
        !selectedServiceEntitlementId ||
        !selectionMode ||
        selectionMode == "2"
      ) {
        this.forceRange = null;
        return;
      }

      var entitlementSummary = this.entitlementSummary;
      var { periodType, selectedPeriod } = newData;

      var forceRange = null;
      var dateToCheck = null;
      if (periodType.indexOf("week") > -1 && selectedPeriod) {
        // --- Get Default Collection Date of that week
        var differenceInTime =
          (selectedPeriod.end - selectedPeriod.start) / (1000 * 60 * 60 * 24);
        var defaultCollectionDay =
          this.selectedService.default_collection_day || 0;

        // --- Scan for the next DefaultCollectionDay
        var cursorDate = new Date(selectedPeriod.start);
        for (let i = 0; i < differenceInTime + 2; i++) {
          if (cursorDate.getDay() == defaultCollectionDay) {
            dateToCheck = cursorDate;
            break;
          } else {
            cursorDate.setDate(cursorDate.getDate() + 1);
          }
        }
        cursorDate = cursorDate || new Date(selectedPeriod.start);
      } else {
        dateToCheck = selectedPeriod;
      }

      dateToCheck = new DateNoTz(dateToCheck).convertToSeconds();
      // --- Find Period of dateToCheck
      var periods = [
        entitlementSummary.currentPeriod,
        entitlementSummary.nextPeriod,
      ];
      var matchedPeriod = periods.find((period) => {
        var periodStart = new DateNoTz(period.startDate).convertToSeconds();
        var periodEnd = new DateNoTz(period.endDate).convertToSeconds();
        return periodStart <= dateToCheck && dateToCheck <= periodEnd;
      });
      // --- Determine the entitlements for the collection date

      if (matchedPeriod) {
        var availableEntitlements =
          matchedPeriod.entitlementsRemaining[selectedServiceEntitlementId];

        // --- Save to Booking State
        this.$emit("update", {
          availableEntitlements,
        });

        if (this.selected > availableEntitlements) {
          this.modalDesc = Texts.render(
            `MULTIPLE_COLLECTION_EXCEEDING_REMAINING`,
            null,
            {
              remainingEntitlements: availableEntitlements,
            }
          );
          this.cachedSelected = availableEntitlements
          $("#exceedMaximumModal").modalbs5({
            show: true,
            backdrop: "static",
            keyboard: false,
          });
        }
      }

      // this.forceRange = forceRange;

      return;

      if (periodType.indexOf("week") > -1 && selectedPeriod) {
        var bookingStart = new DateNoTz(selectedPeriod.start),
          bookingEnd = new DateNoTz(selectedPeriod.end),
          currentEnd =
            entitlementSummary &&
            entitlementSummary.currentPeriod &&
            entitlementSummary.currentPeriod.endDate
              ? new DateNoTz(entitlementSummary.currentPeriod.endDate)
              : null,
          nextStart =
            entitlementSummary &&
            entitlementSummary.nextPeriod &&
            entitlementSummary.nextPeriod.startDate
              ? new DateNoTz(entitlementSummary.nextPeriod.startDate)
              : null;

        if (bookingStart && bookingEnd && currentEnd && nextStart) {
          var doesCollectionPeriodOverlapCurrent =
            bookingStart.convertToSeconds() < currentEnd.convertToSeconds();
          var doesCollectionPeriodOverlapNext =
            bookingEnd.convertToSeconds() > nextStart.convertToSeconds();

          if (
            doesCollectionPeriodOverlapCurrent &&
            doesCollectionPeriodOverlapNext
          ) {
            // --- Find Max Entitlement
            var service = this.selectedService;
            var serviceEntitlementId = this.selectedServiceEntitlementId;

            var currentEntitlement =
              entitlementSummary.currentPeriod.entitlementsRemaining[
                serviceEntitlementId
              ] || 0;
            var nextEntitlement =
              entitlementSummary.nextPeriod.entitlementsRemaining[
                serviceEntitlementId
              ] || 0;

            forceRange =
              currentEntitlement > nextEntitlement
                ? currentEntitlement
                : nextEntitlement;
          }
        }
      }
    },
  },
  methods: {
    loadMultipleCollectionState(serviceCartState) {
      if (serviceCartState) {
        var { multipleCollectionCount } = serviceCartState;
        multipleCollectionCount = this.$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED ? (this.multipleServiceBookingState ? this.multipleServiceBookingState.multipleCollectionCount : multipleCollectionCount) : multipleCollectionCount;
        this.selected = multipleCollectionCount || 1;
        this.serviceData = serviceCartState.service;
        this.determineDisplayOfMultipleCollection();
        this.changeMultipleCollectionCount(multipleCollectionCount);
      }
    },
    changeMultipleCollectionCount(event) {
      const multipleCollectionCount =
        event && event.target && event.target.value
        ? event.target.value
        : 1;
      this.determineDisplayOfMultipleCollection();
      this.$emit("update", {
          multipleCollectionCount,
      });
    },
    reset() {
      this.selected = 1;
    },
    determineDisplayOfMultipleCollection() {
      var serviceData = this.serviceData || this.selectedService;

      // --- Declare display values
      var displayMultipleCollection = false;
      var displayStreamQuantities = false;

      // --- Default to False on Null
      if (
        !serviceData ||
        !this.effectiveEntitlements ||
        !this.multipleCollectionSetting
      ) {
        displayMultipleCollection = false;
        displayStreamQuantities = false;
      } else {
        // --- Check Multiple Entitled Collection for Display
        var entitlementSettingId = serviceData.entitlement_setting_id;
        var selectedServiceId = serviceData.service_setting_id;

        // --- Toggle displays based on multipleCollectionSettings
        if (entitlementSettingId !== null && this.multipleCollectionSetting) {
          displayMultipleCollection =
            this.multipleCollectionSetting.selection == "1";

          /*
            Stry: P2US419_BUG01
            Date: 2020-11-10
            Auth: Franco Mapua
            Desc: Reverting behavior: Stream spinners are no longer dependent on the multiple collection count
          */
          // const multiEntitled = this.selected && this.selected > 1;
          // displayStreamQuantities = this.multipleCollectionSetting.selection == "2" || multiEntitled
          displayStreamQuantities =
            this.multipleCollectionSetting.selection == "2";
        }
      }

      // --- Send the update upstream
      this.displayMultipleCollection = displayMultipleCollection;
      this.displayStreamQuantities = displayStreamQuantities;

      this.$emit("update", {
        displayMultipleCollection,
        displayStreamQuantities,
      });
    },
    determineMaxEntitlementsOfPeriods() {
      /* 
        Stry: US417 
        Date: 2020-11-10
        Auth: Franco Mapua
        Desc: Determining max entitlements based on the entitlement periods that cover the services' available booking dates
      */

      var availableBookingDatesOfService = this.selectedService
        ? this.selectedService.availableBookingDates
        : null;
      var entitlementSummary = this.bookingState
        ? this.bookingState.entitlementSummary
        : null;
      var effectiveEntitlements = this.effectiveEntitlements;
      var serviceEntitlementId = this.selectedServiceEntitlementId;
      var maxEntitlements = 0;
      var selectionMode = this.selectedEntitlementSettings
        ? this.selectedEntitlementSettings.entitlement_usage
        : null;

      if (
        selectionMode == "2" && // --- Booking Date
        serviceEntitlementId &&
        effectiveEntitlements
      ) {
        maxEntitlements =
          entitlementSummary && entitlementSummary.currentPeriod.entitlementsRemaining
            ? entitlementSummary.currentPeriod.entitlementsRemaining[serviceEntitlementId]
            : 0;
      } else if (
        selectionMode == "1" && // --- Collection Day
        Array.isArray(availableBookingDatesOfService) &&
        availableBookingDatesOfService.length > 1 &&
        entitlementSummary &&
        serviceEntitlementId
      ) {
        // --- Get Periods
        var periods = [
          entitlementSummary.currentPeriod,
          entitlementSummary.nextPeriod,
        ];
        // --- Filter Periods to see if any of the available booking dates fall under the criteria
        periods = periods.filter((period) => {
          if (!period.startDate || !period.endDate) {
            return false;
          }

          var periodStart = new DateNoTz(period.startDate).convertToSeconds();
          var periodEnd = new DateNoTz(period.endDate).convertToSeconds();
          var doesPeriodHaveDates = false;
          for (let i = 0; i < availableBookingDatesOfService.length; i++) {
            var bookingDate = availableBookingDatesOfService[i];
            if (bookingDate.availableBookings <= 0) {
              continue;
            } else {
              bookingDate = new DateNoTz(bookingDate.date).convertToSeconds();
              if (periodStart <= bookingDate && bookingDate <= periodEnd) {
                doesPeriodHaveDates = true;
                break;
              }
            }
          }
          return doesPeriodHaveDates;
        });

        // --- Get Maximum of the entitlements
        periods.forEach((period) => {
          var entitlementsRemaining =
            period.entitlementsRemaining[serviceEntitlementId];
          maxEntitlements =
            entitlementsRemaining > maxEntitlements
              ? entitlementsRemaining
              : maxEntitlements;
        });
      }

      return maxEntitlements;
    },
    confirmCallback(){
      this.selected = this.cachedSelected
      this.cachedSelected = null
    },
    denyCallback(){
      this.$emit("resetCalendar")
    },
  },
};
</script>

<style lang="scss" scoped>
.w-2rem {
  width: 2rem;
}
</style>